import React, { useState, useCallback, useEffect } from 'react'
import "./Home.css"
import bannerimg from "../PortfolioPics/Group 48095395.png"
import halfpastlogo from "../PortfolioPics/Group 48095392.png"
import brainlogo from "../PortfolioPics/Group 1000001818 (1).png"
import amzlogo from "../PortfolioPics/Group.png"
import zoologo from "../PortfolioPics/Group 1000001834.png"
import workimg from "../PortfolioPics/Group 48095388.png"
import { portfolio } from "./Portfolio"
import aboutimg from "../PortfolioPics/Image (2).png"
import designlogo1 from "../PortfolioPics/Group 1380.png"
import designlogo2 from "../PortfolioPics/Group 1379.png"
import designlogo3 from "../PortfolioPics/Group 48095384.png"
import designlogo4 from "../PortfolioPics/Group 1378 (1).png"
import reviewprofile1 from '../PortfolioPics/Unsplash-Avatars_0000s_0035_azamat-zhanisov-a5sRFieA3BY-unsplash 1.png'
import reviewprofile2 from '../PortfolioPics/Unsplash-Avatars_0001s_0005_sirio-jxE_5_HqSJY-unsplash.png'
import reviewprofile3 from '../PortfolioPics/Unsplash-Avatars_0002s_0003_mika-H6AuL8bcRkM-unsplash.png'
import Footer from './Footer'
import NavBar from './NavBar'
import Particles from 'react-tsparticles'
import { loadFull } from "tsparticles";
import config from './ParticlesAnimation'
import AOS from "aos"
import 'aos/dist/aos.css'
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss';
import WOW from "wowjs"
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom'
import Cursor from 'react-cursor-follow'
import CountUp from 'react-countup'





function Home() {

  const [isOpen, setOpen] = useState(false)
  const [active, setactive] = useState(false)

  const [filterdata, setFilterData] = useState(portfolio);
  const [noOfCard, setnoOfCard] = useState(4);

  const sliceCard = filterdata.slice(0, noOfCard);




  const init = useCallback(async (engine) => {
    await loadFull(engine)
  })

  useEffect(() => {
    AOS.init({ duration: 2000 })
    new WOW.WOW({
      live: true
    }).init()
  }, [])

  // const [data, setdata] = useState(portfolio)

  // console.log(data)

  return (
    <div>

      <div className='container-fluid home-div1' id='home'>
        {/* <Particles ClassName='particles' params={config.particles} init={init} height="50" /> */}

        <div className='container home-con-div1'>
          <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="tsI1AiANv90" onClose={() => setOpen(false)} />

          <div className="row align-items-center">
            <div className='col-12'>
              <div>
                <Fade top distance="6%" duration={1200}>
                  <h1 className='banner-text1 '>👋 I’m <span>Qasim.</span></h1>
                </Fade>
                <Fade top distance="6%" duration={1200}>
                  <h1 className="banner-text2 ">Graphic &  UI UX  <br></br><span>Designer
                  </span></h1>
                </Fade>
                <Fade top distance="6%" duration={1200}>
                  <p className='banner-para1 '>I am specialized in branding, social media creatives and creating <br className="d-sm-block d-none"></br> user-friendly and massage-focused website & app designs.</p>
                </Fade>
                <Fade top distance="6%" duration={1200}>
                  <div className='d-flex justify-content-center'>

                    <a className='watch-banner-text mx-auto' onClick={() => setOpen(true)}>Watch Video <svg className="ml-3" width="41" height="8" viewBox="0 0 41 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M40.3536 4.35356C40.5488 4.15829 40.5488 3.84171 40.3536 3.64645L37.1716 0.464469C36.9763 0.269207 36.6597 0.269207 36.4645 0.464469C36.2692 0.659731 36.2692 0.976314 36.4645 1.17158L39.2929 4L36.4645 6.82843C36.2692 7.02369 36.2692 7.34027 36.4645 7.53554C36.6597 7.7308 36.9763 7.7308 37.1716 7.53554L40.3536 4.35356ZM-4.37114e-08 4.5L40 4.5L40 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z" fill="white" />
                    </svg>
                    </a>
                  </div>
                </Fade>
              </div>
            </div>

            {/* <div className='col-lg-6 col-12'>
              <div className="banner-img-div" >
                <img src={bannerimg} className="img-fluid banner-img1" alt="" />
              </div>
              <p className='mobile-banner-para1 d-sm-none d-block' data-aos="fade-down">I am specialized in branding, social media creatives and creating user-friendly and massage-focused website & app designs.</p>

            </div> */}
          </div>
        </div>
      </div>

      {/* section #2 */}
      <Fade top distance="3%" duration={1000}>

        <div className='container-fluid home-work-div1'>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-4 col-12 ' >
                <h1 className='work-text1' >I Worked With Different</h1>
                <h1 className='work-text2'>Agencies</h1>
              </div>
              <div className='col-lg-8 col-12 '>
                <div className='row work-company-maindiv'>
                  <div className='col-md-3 col-6  work-col-div' >
                    <a href="https://www.halfpastnine.io/" target="_blank">
                      <div className='work-company-div1 '>
                        <div >
                          <img src={halfpastlogo} className="img-fluid company-logo1" alt="" />
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className='col-md-3 col-6 work-col-div' >
                    <a href="https://www.brainsouls.com" target="_blank">
                      <div className='work-company-div1'>
                        <div>
                          <img src={brainlogo} className="img-fluid company-logo2" alt="" />
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className='col-md-3 col-6 work-col-div' >
                    <a href="https://www.advanceamz.com" target="_blank">
                      <div className='work-company-div1'>
                        <div>
                          <img src={amzlogo} className="img-fluid company-logo3" alt="" />
                        </div>
                      </div>
                    </a>
                  </div>

                  <div className='col-md-3 col-6 work-col-div' >
                    <a href="https://www.graphicszoo.com" target="_blank">
                      <div className='work-company-div1'>
                        <div>
                          <img src={zoologo} className="img-fluid company-logo4" alt="" />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </Fade>
      <Fade top  >
        <div className="vert-line d-sm-block d-none" ></div>
      </Fade>


      {/* section #3 */}

      <div className='container-fluid portfolio-div1' >

        <div className='container' id='figmafolio'>
          <Fade top distance="6%" duration={1200}>
            <h1 className='portfolio-text1' >Creative Work</h1>
          </Fade>

          {/* <h1 className='scroll-text1' >Scroll Down For More</h1> */}
          <Fade top distance="6%" duration={1200}>
            <Link to="/portfolio" className='explore-text1 d-sm-block d-none' >Explore All <svg className='ml-4' width="37" height="14" viewBox="0 0 37 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M37 -2.571e-06L37 14L35 14L35 -2.48357e-06L37 -2.571e-06ZM33 7L27 13L25.59 11.59L29.17 8L-2.62268e-07 8L-3.49691e-07 6L29.17 6L25.59 2.41L27 0.999999L33 7Z" fill="#2F2F2F" />
            </svg>
            </Link>
          </Fade>

          <div className='row'>
            {
              sliceCard.map((port) => {
                return (
                  <div className='col-lg-6 col-12 d-flex justify-content-center'>
                    <Fade top distance="3%" duration={1200}>
                      <div>
                        <div className="d-flex justify-content-center portfolio-img-div" >
                          {port.link && <a href={port.link} target="_blank">
                            <img src={port.img} className="portfolio-img img-fluid mx-auto" alt="" onMouseEnter={() => setactive(true)} onMouseLeave={() => setactive(false)} />
                          </a>}
                        </div>
                        <div className='d-flex align-items-center'>
                          <div>
                            {port.link && <a href={port.link} target="_blank">
                              <h1 className='portfolio-title'>{port.title}</h1>
                            </a>}
                          </div>
                          <div className='ml-auto'>
                            {port.link && <a href={port.link} target="_blank">
                              <svg width="34" height="34" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="37" height="37" fill="black" />
                                <path d="M23.75 14C23.75 13.5858 23.4142 13.25 23 13.25H16.25C15.8358 13.25 15.5 13.5858 15.5 14C15.5 14.4142 15.8358 14.75 16.25 14.75H22.25V20.75C22.25 21.1642 22.5858 21.5 23 21.5C23.4142 21.5 23.75 21.1642 23.75 20.75V14ZM14.5303 23.5303L23.5303 14.5303L22.4697 13.4697L13.4697 22.4697L14.5303 23.5303Z" fill="white" />
                              </svg>
                            </a>}
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>


                )
              })
            }


          </div>
          <Fade top distance="6%" duration={1200}>
            <Link to='/portfolio' className='explore-text1 d-sm-none d-block mx-auto' >Explore All <svg className='ml-3' width="37" height="14" viewBox="0 0 37 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M37 -2.571e-06L37 14L35 14L35 -2.48357e-06L37 -2.571e-06ZM33 7L27 13L25.59 11.59L29.17 8L-2.62268e-07 8L-3.49691e-07 6L29.17 6L25.59 2.41L27 0.999999L33 7Z" fill="#2F2F2F" />
            </svg>
            </Link>
          </Fade>
        </div>
      </div>



      {/* section # 4 */}

      <div className='container-fluid  about-me-div1' id="about-me">
        <div className='row'>
          <Fade left distance="2%" duration={1200}>
            <div className='col-lg-6 col-12 about-img-div1' >
              <div className='about-img-div'>
                <img src={aboutimg} className='about-img img-fluid' alt="" />

                <svg className='about-img-svg' width="56" height="49" viewBox="0 0 56 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M49.8033 48.9899C54.5045 42.482 56.4279 34.3731 55.1504 26.4471C53.8729 18.5211 49.4991 11.4271 42.9912 6.72594C36.4833 2.02473 28.3744 0.101315 20.4483 1.37883C12.5223 2.65635 5.4284 7.03015 0.72719 13.538L25.2652 31.264L49.8033 48.9899Z" fill="url(#paint0_linear_720_947)" />
                  <defs>
                    <linearGradient id="paint0_linear_720_947" x1="9.74034" y1="-17.294" x2="50.1021" y2="76.3824" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#468CF0" />
                      <stop offset="1" stop-color="#154FA3" />
                    </linearGradient>
                  </defs>
                </svg>

                <div className='years-div'>
                  <h1 className='years-text1'>9+</h1>
                  <h1 className='years-text2'>Years Of <br></br> Experience</h1>
                  <h1 className='years-text3'>That's what <br /> make me <br /> different</h1>

                </div>
              </div>
            </div>
          </Fade>
          <Fade right distance="2%" duration={1200}>
            <div className='col-lg-6 col-12 about-text-div1' >
              <div>
                <h1 className='about-me-text1'>About Me</h1>
                <h1 className='about-me-text2'>Mr Qasim</h1>
                <p className='about-me-text3'>Hello, I am Muhammad Qasim, a User Experience Designer specializing in branding, Social media creatives and creating user-friendly and massage-focused website & app designs. I am capable within a wide range of tactical and big-picture design tasks.</p>
                <p className='about-me-text4'>I am passionate about making sure that systems, interfaces, language and graphics are human-friendly, emotive, aesthetically pleasing, clear, on-brand and usable — with a touch of mellow smoothness.</p>
              </div>
            </div>
          </Fade>
        </div>
      </div>



      {/* section # 5 */}

      <div className='container-fluid design-div1'>
        <div className='container design-div2'>
          <Fade top distance="6%" duration={1200}>
            <h1 className='design-text1' >Design Technologies <br className='d-sm-none d-block'></br> I Work With</h1>
          </Fade>
          <Fade top distance="6%" duration={1200}>
            <p className='design-text2' >I use photoshop, Illustrator, XD and Figma</p>
          </Fade>
          <div className='row  deignlogo-div'>
            <Fade top distance="6%" duration={1200}>
              <div >
                <img src={designlogo1} className="img-fluid design-logo" alt="" />
              </div>
              <div >
                <img src={designlogo2} className="img-fluid design-logo" alt="" />
              </div>
              <div >
                <img src={designlogo3} className="img-fluid design-logo" alt="" />
              </div>
              <div >
                <img src={designlogo4} className="img-fluid design-logo" alt="" />
              </div>
            </Fade>

          </div>
        </div>
      </div>


      {/* <Footer></Footer> */}


    </div>


  )
}

export default Home